import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import "./interview.css";
import { faAngleRight, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
// import { faCircleDown } from '@fortawesome/free-regular-svg-icons';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
// import Avatar from '@mui/material/Avatar';
// import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
// import Select from 'react-select';
// import { useNavigate } from 'react-router-dom';
// import { MenuItem, TextField } from '@mui/material';
// import { saveAs } from 'file-saver';
// import Papa from 'papaparse';
import { apiService } from '../../../../services/apiService';
function Opportunity() {
    const navigate = useNavigate();
    const [opportunityList, setOpportunity] = useState([]);
    const [loading, setLoading] = useState(true);
    const [paginatedata, setPaginateData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);

    const fetchOpportunity = useCallback(async (params = {}) => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`catalog/interview/opportunity_interview_list`);
            setOpportunity(response.data);
            setPaginateData(response.meta);
        } catch (error) {
            console.error('Error fetching tab data:', error);
        }finally {
            setLoading(false);
        }
    }, []);

    // Handle page change
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        fetchOpportunity({ page: newPage });
    };

    // Handle search query change
    // const handleSearch = () => {
    //     setCurrentPage(1);
    //     fetchOpportunity({ search: searchQuery });
    // };

    // Fetch initial data on component mount
    useEffect(() => {
        fetchOpportunity();
    }, [fetchOpportunity]);
    // const [isGridVisible, setGridVisible] = useState(false);
    // const [currentPage, setCurrentPage] = useState(0);
    // const [pageSize, setPageSize] = useState(10);
    // const handleShow = () => setShow(true);

    
    // const toggleGrid = () => {
    //     setGridVisible((prev) => !prev);
    // };

    // const [filters, setFilters] = useState([{ operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);


    // const combineOptions = [
    //     { value: 'And', label: 'And' },
    //     { value: 'Or', label: 'Or' },
    // ];

    const rows = opportunityList && opportunityList.map((datas, index) => ({
        uniqueKey: `${datas.id}-${index}`,
        id: datas.id,
        format_id: datas.opportunity_number,
        jobTitle: datas.job_title,
        companyName: datas.company_name,
        clientName: datas.client_name,
        siteType: datas.site_type,
        status: datas.status,
        catalogSlug: datas.catalog_slug,
        userName: datas.name,
        contactPhone: datas.phone_number,
        contactEmail: datas.email,
        suspended: datas.suspended,
        nextRoundStatus: datas.next_round_status,
        firstRoundStatus: datas.first_round_status,
    }));

    // const handleFilterChange = (index, field, value) => {
    //     const newFilters = [...filters];
    //     // Reset value if changing the column type
    //     if (field === 'column') {
    //         newFilters[index].value = newFilters[index].column === 'date' ? [null, null] : '';
    //     }
    //     newFilters[index][field] = value;
    //     setFilters(newFilters);
    // };

    // const addFilter = () => {
    //     setFilters([...filters, { operator: 'And', column: 'userName', operatorType: 'contains', value: '' }]);
    // };

    // const removeFilter = (index) => {
    //     setFilters(filters.filter((_, i) => i !== index));
    // };
    // useEffect(() => {
    //     const fetchData = async () => {
    //         const response = await apiService.getRequest('admin/roles-list');
    //         if (response.success) {
    //             setCitizenshipStatuses(response.data);
    //         }
    //     };
    //     fetchData();
    // }, []);
    // const operatorOptions = [
    //     { value: 'contains', label: 'contains' },
    //     { value: 'doesNotContain', label: 'does not contain' },
    //     { value: 'startsWith', label: 'starts with' },
    //     { value: 'endsWith', label: 'ends with' },
    //     { value: 'is', label: 'is' },
    //     { value: 'isNot', label: 'is not' },
    //     { value: 'isEmpty', label: 'is empty' },
    //     { value: 'isNotEmpty', label: 'is not empty' },
    // ];
    // const getOperatorOptions = (column) => {
    //     if (column === 'group') {
    //         return [
    //             { value: 'contains', label: 'contains' },
    //             { value: 'doesNotContain', label: 'does not contain' },
    //             { value: 'startsWith', label: 'starts with' },
    //             { value: 'endsWith', label: 'ends with' },
    //             { value: 'is', label: 'is' },
    //             { value: 'isNot', label: 'is not' },
    //             { value: 'isOneOf', label: 'is one of' },
    //             { value: 'isNotOneOf', label: 'is not one of' },
    //             { value: 'isEmpty', label: 'is empty' },
    //             { value: 'isNotEmpty', label: 'is not empty' },
    //         ];
    //     }
    //     return operatorOptions; // Default options
    // };
    
    // const filteredRows = rows.filter((row) =>
    //     filters.reduce((acc, filter, index) => {
    //         const rowValue = row[filter.column] ? row[filter.column].toString() : '';
    //         let matches = false;
    
    //         if (filter.column === 'group') {
    //             switch (filter.operatorType) {
    //                 case 'is':
    //                     matches = rowValue === filter.value;
    //                     break;
    //                 case 'isNot':
    //                     matches = rowValue !== filter.value;
    //                     break;
    //                 case 'contains':
    //                     matches = typeof filter.value === 'string' && rowValue.toLowerCase().includes(filter.value.toLowerCase());
    //                     break;
    //                 case 'doesNotContain':
    //                     matches = typeof filter.value === 'string' && !rowValue.toLowerCase().includes(filter.value.toLowerCase());
    //                     break;
    //                 case 'startsWith':
    //                     matches = typeof filter.value === 'string' && rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
    //                     break;
    //                 case 'endsWith':
    //                     matches = typeof filter.value === 'string' && rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
    //                     break;
    //                 case 'isEmpty':
    //                     matches = rowValue === '';
    //                     break;
    //                 case 'isNotEmpty':
    //                     matches = rowValue !== '';
    //                     break;
    //                 case 'isOneOf': // Check if at least one role matches
    //                     matches = Array.isArray(filter.value) && 
    //                         rowValue.split(', ').some(role => filter.value.includes(role));
    //                     break;
    //                 case 'isNotOneOf': // Ensure no roles match
    //                     matches = Array.isArray(filter.value) && 
    //                         !rowValue.split(', ').some(role => filter.value.includes(role));
    //                     break;
    //                 default:
    //                     matches = false;
    //             }
    //         } else {
    //             // General filter logic for other columns
    //             switch (filter.operatorType) {
    //                 case 'contains':
    //                     matches = rowValue.toLowerCase().includes(filter.value.toLowerCase());
    //                     break;
    //                 case 'doesNotContain':
    //                     matches = !rowValue.toLowerCase().includes(filter.value.toLowerCase());
    //                     break;
    //                 case 'startsWith':
    //                     matches = rowValue.toLowerCase().startsWith(filter.value.toLowerCase());
    //                     break;
    //                 case 'endsWith':
    //                     matches = rowValue.toLowerCase().endsWith(filter.value.toLowerCase());
    //                     break;
    //                 case 'is':
    //                     matches = rowValue === filter.value;
    //                     break;
    //                 case 'isNot':   
    //                     matches = rowValue !== filter.value;
    //                     break;
    //                 case 'isEmpty':
    //                     matches = rowValue === '';
    //                     break;
    //                 case 'isNotEmpty':
    //                     matches = rowValue !== '';
    //                     break;
    //                 default:
    //                     matches = false;
    //             }
    //         }
    
    //         return index === 0 ? matches : (filter.operator === 'And' ? acc && matches : acc || matches);
    //     }, true)
    // );

    // useEffect(() => {
    //     setCurrentPage(0);
    // }, [filters]);
    // const paginatedRows = filteredRows.slice(currentPage * pageSize, currentPage * pageSize + pageSize);
    
    const columns = [
        {
            field: 'format_id',
            headerName: 'ID',
            minWidth: 250,
            flex: 1,
            renderCell: (params) => (
                <div className='d-flex align-items-center h-100'>
                    {params.row.nextRoundStatus === true ?
                        <Link to={`/catalogs/interviews-booking/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.format_id}</Link>:
                        params.row.firstRoundStatus === true ?
                        <Link to={`/catalogs/interviews-booking/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.format_id}</Link>:
                        <Link to={`/catalogs/interviews-booking/${params.row.id}`} className='cursetespoint' style={{color:"#C42B7D",textDecoration:"none"}} >{params.row.format_id}</Link>
                    }
                </div>
            ),
            filterable: false,
        },
        {
            field: 'jobTitle',
            headerName: 'Job Title',
            minWidth: 350,
            flex: 1,
            filterable: false,
        },
        {
            field: 'companyName',
            headerName: 'Company Name',
            minWidth: 350,
            flex: 1,
            filterable: false,
        },
        {
            field: 'clientName',
            headerName: 'Client Name',
            minWidth: 350,
            flex: 1,
            filterable: false,
        },
        {
            field: 'siteType',
            headerName: 'Site Type',
            minWidth: 350,
            flex: 1,
            filterable: false,
        },
        {
            field: 'status',
            headerName: 'Status',
            minWidth: 350,
            flex: 1,
            filterable: false,
        },
        // {
        //     field: 'userName',
        //     headerName: 'Sub Admin',
        //     minWidth: 350,
        //     flex: 1,
        //     renderCell: (params) => (
        //         <div className='d-flex align-items-center h-100'>
        //             <Avatar src={params.row.userImage} alt={params.row.userName} />
        //             <span className='ms-3'>{params.row.userName}</span>
        //         </div>
        //     ),
        //     filterable: true
        // },
        
        // {
        //     field: 'contactPhone',
        //     headerName: 'Phone',
        //     minWidth: 250,
        //     flex: 1,
        //     filterable: true,
        //     renderCell: (params) => (
        //         <Box className="linklistview h-100 d-flex align-items-center">
        //             <Typography><span><a href={`tel:${params.row.contactPhone}`} target="_blank" rel="noopener noreferrer">{params.row.contactPhone}</a></span></Typography>
        //         </Box>
        //     ) 
        // },
        // {
        //     field: 'contactEmail',
        //     headerName: 'Email',
        //     minWidth: 300,
        //     flex: 1,
        //     filterable: true,
        //     renderCell: (params) => (
        //         <Box className="linklistview h-100 d-flex align-items-center">
        //             <Typography><span><a href={`mailto:${params.row.contactEmail}`} target="_blank" rel="noopener noreferrer">{params.row.contactEmail}</a></span></Typography>
        //         </Box>
        //     )
        // },
    ];
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="space-between">
                    <Grid size={{xs:12}} container flexDirection="column" className="jobseekerhead">
                        <h3>Interviews Booking</h3>
                        <span><b onClick={()=>navigate("/dashboard")}>Dashboard</b> <FontAwesomeIcon className='angleright' icon={faAngleRight} /> <b onClick={()=>navigate("/catalogs/consulting-services")}>Catalog</b><FontAwesomeIcon className='angleright' icon={faAngleRight} /> Interviews Booking <FontAwesomeIcon className='angleright' icon={faAngleRight} /> Opportunity</span>
                    </Grid>
                </Grid>
                <Grid size={{md:12,xs:12}} container justifyContent="flex-end" alignItems="center" className="mt-4">
                    <Grid size={{xs:12}} container justifyContent="flex-end">
                        <button onClick={()=>navigate("/catalogs/create-opportunity")} className='registersendbtn2 px-4' style={{width:"max-content"}}>Add Opportunity</button>
                    </Grid>
                    {loading ? 
                        <div className='d-flex justify-content-center w-100'>
                            <img style={{ width: "100px" }} src={require('../../../../assets/pinkloader.gif')} alt='Loading...' />
                        </div> :<>
                        <Box sx={{ height: "unset !important", width: '100%' }} className="datatable_jobpagi">
                            <DataGrid
                                style={{minHeight:"300px"}}
                                rows={rows}
                                columns={columns}
                                getRowId={(row) => row.uniqueKey}
                                disableSelectionOnClick
                                components={{ Toolbar: GridToolbar }}
                            />
                            {/* <div className='d-flex flex-column my-3 pagination_datagrid'>
                                <div className='d-flex justify-content-end align-items-center'>
                                    <label>No. of Rows</label>
                                    <select
                                        label="Rows per page"
                                        value={pageSize}
                                        onChange={(e) => {setPageSize(Number(e.target.value)); setCurrentPage(0);}}
                                        sx={{ mr: 2 }}
                                    >
                                        {[5, 10, 20, 50].map((size) => (
                                            <option key={size} value={size}>{size}</option>
                                        ))}   
                                    </select>
                                </div>

                                <div className="d-flex justify-content-center mt-3">
                                    <button
                                        className='nexter_btns'
                                        variant="contained"
                                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                                        disabled={currentPage === 0}
                                    >
                                        <FontAwesomeIcon icon={faChevronLeft} />
                                    </button>

                                    {filteredRows.length > 0 && (
                                        <div className="d-flex align-items-center mx-2">
                                            {(() => {
                                            const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
                                            const pages = [];

                                            const start = Math.max(1, currentPage + 1 - 2);
                                            const end = Math.min(totalPages - 1, currentPage + 1 + 2);

                                            pages.push(
                                                <button
                                                key={1}
                                                className={`page-btn ${currentPage === 0 ? 'active' : ''}`}
                                                onClick={() => setCurrentPage(0)}
                                                >
                                                1
                                                </button>
                                            );

                                            if (start > 2) {
                                                pages.push(<span key="start-ellipsis" className="px-1">...</span>);
                                            }

                                            for (let i = start; i <= end; i++) {
                                                if (i !== 1 && i !== totalPages) {
                                                pages.push(
                                                    <button
                                                    key={i}
                                                    className={`page-btn ${currentPage === i - 1 ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(i - 1)}
                                                    >
                                                    {i}
                                                    </button>
                                                );
                                                }
                                            }

                                            if (end < totalPages - 1) {
                                                pages.push(<span key="end-ellipsis" className="px-1">...</span>);
                                            }

                                            if (totalPages > 1) {
                                                pages.push(
                                                <button
                                                    key={totalPages}
                                                    className={`page-btn ${currentPage === totalPages - 1 ? 'active' : ''}`}
                                                    onClick={() => setCurrentPage(totalPages - 1)}
                                                >
                                                    {totalPages}
                                                </button>
                                                );
                                            }

                                            return pages;
                                            })()}
                                        </div>
                                    )}
    
                                    <button  
                                        className='nexter_btns'
                                        variant="contained"
                                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(filteredRows.length / pageSize) - 1))}
                                        disabled={currentPage >= Math.ceil(filteredRows.length / pageSize) - 1}
                                    >
                                        <FontAwesomeIcon icon={faChevronRight} />
                                    </button>
                                </div>
                            </div> */}
                        </Box>
                    </>}
                </Grid>
                <Grid size={{xs:12}} container justifyContent="center" className="mt-4 pagination_btn">
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage - 1)} 
                        disabled={currentPage === 1}>
                        <FontAwesomeIcon icon={faChevronLeft} />
                    </button>
                    {paginatedata && paginatedata?.last_page > 0 && (
                        <div className="pagination">
                            {(() => {
                            const totalPages = Math.max(1, paginatedata?.last_page);
                            const pages = [];

                            const start = Math.max(2, currentPage - 2);
                            const end = Math.min(totalPages - 1, currentPage + 2);

                            // Always show page 1
                            pages.push(
                                <button
                                key={1}
                                onClick={() => handlePageChange(1)}
                                className={currentPage === 1 ? 'active' : ''}
                                >
                                1
                                </button>
                            );

                            // Ellipsis after page 1 if needed
                            if (start > 2) {
                                pages.push(<span key="start-ellipsis">...</span>);
                            }

                            // Middle pages
                            for (let i = start; i <= end; i++) {
                                pages.push(
                                <button
                                    key={i}
                                    onClick={() => handlePageChange(i)}
                                    className={currentPage === i ? 'active' : ''}
                                >
                                    {i}
                                </button>
                                );
                            }

                            // Ellipsis before last page if needed
                            if (end < totalPages - 1) {
                                pages.push(<span key="end-ellipsis">...</span>);
                            }

                            // Always show last page (if more than 1)
                            if (totalPages > 1) {
                                pages.push(
                                <button
                                    key={totalPages}
                                    onClick={() => handlePageChange(totalPages)}
                                    className={currentPage === totalPages ? 'active' : ''}
                                >
                                    {totalPages}
                                </button>
                                );
                            }

                            return pages;
                            })()}
                        </div>
                    )}
                    <button className='arrowpaginate'
                        onClick={() => handlePageChange(currentPage + 1)} 
                        disabled={currentPage === paginatedata?.last_page}>
                        <FontAwesomeIcon icon={faChevronRight} />
                    </button>
                </Grid>
            </Grid>
            
        </div>
    </div>
  )
}

export default Opportunity
